import * as Yup from "yup";

export const couponValidationSchema = Yup.object({
  coupon: Yup.string().required().max(50),
});
